import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=6a1ca5b2&scoped=true&"
import script from "./groups.vue?vue&type=script&lang=js&"
export * from "./groups.vue?vue&type=script&lang=js&"
import style0 from "./groups.vue?vue&type=style&index=0&id=6a1ca5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ca5b2",
  null
  
)

export default component.exports